import React from 'react';
import ClayModal from "@clayui/modal";
import { CGE } from '../CGE';
import "../../styles/modalAlert.scss";
import { getPathName } from '../../utils/utilsFunc';


export default function AlertModal ({labelBtnConfirm,labelBtnCancel,btnCancel=true,titleModal,msgModal,observer,onClose, status = 'success',confirm = false,funcClick,children,block=false}) {
    const [classResponse,setClassResponse] = React.useState(false);

    if(confirm && status === "success"){
        titleModal = "Exito";
    }else if(confirm) {
        status = "info";
        if(!titleModal){
            titleModal = "Atención";
        }
    }

    React.useEffect(() => {
        if (getPathName().includes('aporte-de-lectura')) {
            setClassResponse(true);
        }
    },[]);
    
	return (
        <>
            <ClayModal 
                observer={observer}
                size="md"
                status={status}
                className={classResponse ? "class-response" : ""}
                disableAutoClose={block}
                showCloseButton={false}
            >
                {!block && (<ClayModal.Header>{titleModal}</ClayModal.Header> )}
                <ClayModal.Body>
                    <h4>
                        <CGE.RenderContent textContent={msgModal} />
                    </h4>
                    {children}
                </ClayModal.Body>
                {confirm ?
                    <ClayModal.Footer
                        last={
                            <div className="d-flex">
                                {btnCancel &&
                                    <CGE.Button
                                        label={labelBtnCancel ? labelBtnCancel : "Cancelar"}
                                        onClick={onClose}
                                        className=" mr-3"
                                        size="sm"
                                        type="secondary"
                                    />
                                }
                                <CGE.Button
                                    label={labelBtnConfirm ? labelBtnConfirm : "Aceptar"}
                                    onClick={funcClick}
                                    size="sm"
                                />
                            </div>
                        }
                    />
                    :
                    <ClayModal.Footer
                        last={
                            <CGE.Button
                                label="Cerrar"
                                onClick={onClose}
                                className="mb-2"
                                size="sm"
                            />
                        }
                    />
                }
            </ClayModal>
        </>
    );
}